"use client";

import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import { useAuth } from "./context/UserContext";

export const RequireAuth = ({ children }: { children: React.ReactNode }) => {
    const { user, accessToken, hydrated } = useAuth();
    const router = useRouter();
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        setIsClient(true);
    }, []);

    useEffect(() => {
        if (hydrated && (!user || !accessToken)) {
            router.replace("/");
        }
    }, [user, accessToken, hydrated, router]);

    // On server-side or during hydration, render a minimal div to prevent layout shifts
    if (!isClient || !hydrated) {
        return <div style={{ visibility: "hidden" }} />;
    }

    // After hydration, if not authenticated, render nothing
    if (!user || !accessToken) return null;

    // Fully authenticated and hydrated
    return <>{children}</>;
};
